import React from 'react';
// import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
// import { portalActions } from "../../store/portal-slice";
// import { getLocalStore, setLocalStore } from "helpers/localStoreSrv";
// import whitelabelConfig from "@whitelabel-config";
// import { useUiState } from "helpers/useUiState";
import { useApi } from "helpers/useApi";
// import api from "helpers/api";
export const useDashboardsrv = () => {
    // const { isAppLoading } = useUiState();
    // const dispatch = useDispatch();
    const { api } = useApi();
    const portalSessionMeta = useSelector((state: any) => state.portal.micrositeSession);
    console.log("portalSessionMeta", portalSessionMeta)
  
  
   const httpgetMemeberBanner=()=> {
        return api.get('/api/memberbanners');
      } 
   
  
  
    return {  httpgetMemeberBanner }
}